import React, { useState, useEffect } from "react";
import { useAlert } from "react-alert";
import axios from "axios";
import { APIURL } from "../../Global";
import "./leave.css";
import PlannedLeaves from "./PlannedLeaves";
import NurseHolidayPlanner from "./NurseHolidayPlanner";
import Club from "./Club";
const Leave = () => {
    const [expandedDiv, setExpandedDiv] = useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const [reload, setReload] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const alert = useAlert()
    const toggleExpand = (divId) => {
        setExpandedDiv(expandedDiv === divId ? null : divId);
    };

    const handleReload=()=>{
        setReload(!reload)
    }

    return (
        <div className="nurse-roster-container">
            {/* Top Row */}
            {(!expandedDiv || expandedDiv === "left" || expandedDiv === "right") && (
                <div className="top-row">
                    {/* Left Column */}
                    {!expandedDiv || expandedDiv === "left" ? (
                        <div
                            className={`column left ${expandedDiv === "left" ? "expandeda" : ""
                                }`}
                            style={{ flex: expandedDiv === null ? 2 : 1 }}
                        >
                            <div
                                className="expand-icon"
                                onClick={() => toggleExpand("left")}
                                style={{ display: "flex", justifyContent: "space-between" }}
                            >
                                <label>Weekly off</label>
                                <label>{expandedDiv === "left" ? "❌" : "↗"}</label>
                            </div>
                            <div><NurseHolidayPlanner startDate={startDate} setStartDate={setStartDate} handleReload={handleReload} /></div>
                        </div>
                    ) : null}

                    {/* Right Column */}
                    {!expandedDiv || expandedDiv === "right" ? (
                        <div
                            className={`column right ${expandedDiv === "right" ? "expandeda" : ""
                                }`}
                        >
                            <div
                                className="expand-icon"
                                onClick={() => toggleExpand("right")}
                                style={{ display: "flex", justifyContent: "space-between" }}
                            >
                                <label>Leave Requests</label>
                                <label>{expandedDiv === "right" ? "❌" : "↗"}</label>
                            </div>
                            <div><PlannedLeaves handleReload={handleReload}/></div>
                        </div>
                    ) : null}
                </div>
            )}

            {/* Bottom Row */}
            {(!expandedDiv || expandedDiv === "bottom") && (
                <div
                    className={`column bottom ${expandedDiv === "bottom" ? "expandeda" : ""
                        }`}
                >
                    <div className="expand-icon" onClick={() => toggleExpand("bottom")} style={{ display: "flex", justifyContent: "space-between" }}>
                        <label>Combined Weekly Offs and Approved Leaves</label>
                        <label> {expandedDiv === "bottom" ? "❌" : "↗"}</label>
                    </div>
                    <div><Club date={startDate} reload={reload} /></div>
                </div>
            )}
        </div>
    );
};

export default Leave;
